import Joi from 'joi';

export interface ICustomProductVariantsProps {
  sizeLabel: string;
  scentLabel: string;
  retailersTitle: string;
  titles: string;
  descriptions: string;
  images: string;
  sizes: string;
  scents: string;
  retailers: string;
}

const stringRequired = Joi.string().required();
const stringOptional = Joi.string().optional().allow('');

export const customProductVariantsSchema = Joi.object<ICustomProductVariantsProps>({
  sizeLabel: stringOptional,
  scentLabel: stringOptional,
  retailersTitle: stringOptional,
  titles: stringRequired,
  descriptions: stringOptional,
  images: stringOptional,
  sizes: stringOptional,
  scents: stringOptional,
  retailers: stringOptional,
}).options({ stripUnknown: true });
